<template>
  <div>
    <div class="d-none d-print-flex flex-row flex-wrap">
      <div class="" v-html="scenarioTitle"></div>
    </div>
    <div class="d-flex d-print-none"></div>

    <div class="d-flex flex-wrap align-center d-flex d-print-none">
      <div class="mr-2 font-weight-medium labelWidth">Correction</div>
      <v-btn-toggle
        v-model="correction"
        @change="calculateCorrection()"
        :mandatory="true"
        rounded
        class="toggleBtns mr-6"
        active-class="orangeActive"
      >
        <v-btn :value="null" x-small>None</v-btn>
        <v-btn value="distance" x-small> Distance</v-btn>
        <v-btn x-small value="computer">Computer</v-btn>
        <v-btn x-small value="near_rx">Near Rx </v-btn>
        <v-btn x-small value="near_otc"
          ><span v-if="!isMobile">Near </span>OTC</v-btn
        >
        <v-btn x-small value="cl">CL </v-btn>
      </v-btn-toggle>
    </div>

    <div class="d-flex flex-row flex-wrap align-start my-print-0 d-print-none">
      <div>
        <v-expand-transition>
          <div v-if="correction == 'near_otc'" class="d-flex flex-wrap my-3">
            <div class="mr-2 font-weight-medium labelWidth">OTC Power</div>
            <v-btn-toggle
              v-model="correction_otc"
              rounded
              class="toggleBtns btnBottom"
              active-class="orangeActive"
              @change="calculateCorrection()"
            >
              <v-btn
                x-small
                v-for="add in [1, 1.25, 1.5, 1.75, 2, 2.25, 2.5, 3]"
                :key="add"
                :value="add"
                ><span v-if="!isMobile">+</span
                >{{ isMobile ? add : numToDiopterString(add) }}</v-btn
              >
            </v-btn-toggle>
          </div>
        </v-expand-transition>
        <div>
          <v-expand-transition>
            <div v-if="contactLens">
              <div class="d-flex flex-wrap align-center my-2">
                <div class="mr-2 font-weight-medium labelWidth">Max Cyl</div>
                <v-btn-toggle
                  v-model="maxCyl"
                  @change="calculateCorrection()"
                  rounded
                  class="toggleBtns mr-4 my-0 mt-1"
                  active-class="orangeActive"
                >
                  <v-btn x-small :value="0">None</v-btn>
                  <v-btn x-small :value="1.75"> 1.75</v-btn>
                  <v-btn x-small :value="2.25">2.25</v-btn>
                  <v-btn x-small :value="2.75"> 2.75</v-btn>
                  <v-btn x-small :value="maxCylLimit">Full Cyl</v-btn>
                </v-btn-toggle>
              </div>

              <v-expand-transition>
                <div class="d-flex flex-row align-center" v-if="contactLens">
                  <div class="mr-2 font-weight-medium labelWidth">Rotation</div>

                  <div style="min-width: 200px" class="d-print-none">
                    <v-slider
                      v-model="rotation"
                      min="-10"
                      max="10"
                      step="1"
                      @input="calculateCorrection()"
                      :hide-details="true"
                      dense
                    >
                    </v-slider>
                  </div>
                  <img
                    class="rotatingLens"
                    src="https://www.eyedock.com/images/visionSimulator/contactLens.svg"
                    :style="{ transform: `rotate(${scaledRotation}deg)` }"
                  />
                  <div class="ml-2">{{ Math.abs(scaledRotation) }}°</div>
                </div>
              </v-expand-transition>
            </div>
          </v-expand-transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RxMethods from "@/assets/js/cls/RxMethods";
// import SimplePopover from "@/components/universalStuff/SimplePopover.vue";
import VsDefinitions from "./VsDefinitions";

export default {
  name: "VsScenarioSettings",
  components: {
    // SimplePopover,
  },
  mixins: [RxMethods],
  props: {
    rxs: null,
    templateData: null,
    lookingAtText: null,
  },
  data: function () {
    return {
      correction: null,

      correction_otc: 1,
      progressBarAccom: 30,
      toric: true,
      maxCyl: 20,
      maxCylLimit: 20,
      rotation: 0,
    };
  },
  methods: {
    // ? should I be doing this calc somewhere else (not in the settings component)?
    calculateCorrection() {
      let rxs = this.rxs;
      let correction = this.correction;
      // let correction_other = this.correction_other;
      let rtn = { od: null, os: null };
      let correctionType = null;
      ["od", "os"].forEach((eye) => {
        let rtnEye = this.setRxObjectParameters(rxs[eye]);
        // set the right correction for the desired distance
        if (!correction) {
          rtnEye = this.newRxObject();
        } else if (correction == "computer") {
          rtnEye.sph = rtnEye.sph ? rtnEye.sph + 1.25 : 1.25;
        } else if (correction == "near_rx") {
          rtnEye.sph = rtnEye.sph ? rtnEye.sph + 2.5 : 2.5;
        } else if (correction == "near_otc") {
          rtnEye.sph = parseFloat(this.correction_otc);
          rtnEye.cyl = 0;
        } else if (correction == "cl") {
          if (this.maxCyl != this.maxCylLimit) {
            rtnEye = this.rxWithMaxCyl(rtnEye, this.maxCyl); // from RxMethods
          }
          if (this.rotation != 0) {
            rtnEye.axis = this.fixAxis(rtnEye.axis + this.scaledRotation);
          }
        }

        if (correction)
          correctionType =
            this.contactLens && this.contactLens ? "cl" : "glasses";

        rtn[eye] = rtnEye;
      });
      this.$emit("correctionRx", rtn);
      this.$emit("correctionType", correctionType);
    },

    populateTemplateData() {
      let data = this.templateData;
      if (!data) return;
      if (data.correction) this.correction = data.correction;
      // console.log(data);
      if (data.maxCyl) this.maxCyl = data.maxCyl;
      if (data.age) this.age = data.age;
      this.calculateCorrection();
      // this.ageChange();
    },
  },

  computed: {
    isMobile: function () {
      return this.$vuetify.breakpoint.smAndDown;
    },
    accommodationOptions: function () {
      return VsDefinitions.accommodationOptions;
    },
    accommodationOptionsObj: function () {
      let rtn = {};
      this.accommodationOptions.forEach((option) => {
        rtn[option.value] = option;
      });
      return rtn;
    },
    scenarioTitle: function () {
      let rtnArr = [
        // this.ageDescription + this.accomDescription,
        this.correctedStatus,
      ];
      if (this.clStatus) rtnArr.push(this.clStatus);
      // if (this.lookingAtText) rtnArr.push(this.lookingAtText);
      let rtn = rtnArr.join(", ") + ".";
      this.$emit("correctionText", rtn);
      return rtn;
    },

    correctedStatus: function () {
      if (this.correction) {
        if (this.correction == "distance") return "Full distance correction";
        if (this.correction == "computer") return "Computer Correction";
        if (this.correction == "near_rx") return "Near Correction";
        if (this.correction == "cl") return "Contact lenses correction";
        if (this.correction == "near_otc")
          return `+${this.numToDiopterString(this.correction_otc)} OTC readers`;
      }

      return "Uncorrected";
    },
    clStatus: function () {
      let rtn = null;
      if (this.contactLens) {
        rtn = "";
        if (this.maxCyl == 0) {
          rtn += "NO astigmatism correction";
        } else if (this.maxCyl < this.maxCylLimit) {
          rtn += `correcting up to ${this.maxCyl}D astigmatism`;
        } else {
          rtn += "with full astigmatism correction";
        }
        // rtn += ")";
        if (this.scaledRotation != 0) {
          rtn += `, rotating ${Math.abs(this.scaledRotation)}° off-axis`;
        }
      }
      return rtn;
    },
    contactLens: function () {
      return this.correction == "cl";
    },

    scaledRotation: function () {
      return -this.rotation * 5;
    },
  },
  watch: {
    templateData: {
      handler: function () {
        this.populateTemplateData();
      },
      deep: true,
    },
    rxs: {
      handler: function () {
        this.calculateCorrection();
      },
      immediate: true,
      deep: true,
    },
  },

  mounted() {
    // console.log(this.externalCorrectionType);
    this.age = this.minAge;
    // this.ageChange();
    if (this.templateData) {
      this.populateTemplateData();
    } else {
      this.calculateCorrection();
      // this.accomAbilityChange();
    }
  },
};
</script>

<style scoped>
.rotatingLens {
  width: 30px;
  transition-duration: 0.1s;
}
.minBtn {
  min-width: 100px !important;
}
.btnBottom {
  margin-bottom: 10px;
}
.labelWidth {
  min-width: 100px;
}
</style>
